import { background } from './classics4.mjs'
import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/240611/C4-williams-{nnn}.png',
}

export default {
  supports360: false,
  layers: [body, background],
  resolveOptions: () => ({}),
}
